import React, {useState} from 'react';
import {Container, Row, Col, Form, InputGroup, FormControl, Button, Carousel} from 'react-bootstrap';
import { ReactTyped } from 'react-typed';
import './styling/home.css';
import ServicesCards from '../components/services';
import ideImage from '../background.png';
import { motion, useInView } from 'framer-motion';
import CalendarBookingWidget from '../components/bookingwidget';
import ContactForm from '../components/contacform';
import reactIcon from '../react.svg';
import appleIcon from '../apple.svg';
import mysqlIcon from '../mysql.svg';
import nodeIcon from '../nodedotjs.svg';
import shopifyIcon from '../shopify.svg';
import wordpressIcon from '../wordpress.svg';
import androidIcon from '../android.svg';
import bootstrapIcon from '../reactbootstrap.svg';
import Pricing from '../components/pricing';
import Projects from '../components/projects';

function Home() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Implement your subscription logic here (e.g., API call)
    console.log("Subscribed with email:", email);
    setSubscribed(true);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const timeOptions = [
    '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM',
    // Add additional time slots as needed
  ];
  return (
    <>
      <div className='background'>
        <Container>
          <div className='main-section'>
            <Row>
                <Col xl={12} lg={12} md={6} sm={12} xs={12}>
                  <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }} // Animation triggers only once upon scroll
                      transition={{ duration: 2 }}
                  >
                      <h1 className='blue'>Welcome to Inter<span className='green'>Webb UK</span></h1>
                      <h3 className='sub-title'> /// Building & Improving your digital <ReactTyped strings={['future🔮.', 'presence👥.','success🏆.','identity🔑.','growth📈.','brand🏷️.']} typeSpeed={40} backSpeed={50} loop></ReactTyped></h3>
                      <button className='primary-btn'>Contact Us</button>
                      <button className='secondary-btn'>See our Work</button>
                      <div className="subscribe-section mt-4">
                        <h5>Get 25% Off Your First Project!</h5>
                          <Form onSubmit={handleSubscribe} className="d-flex">
                            <InputGroup>
                              <FormControl
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={handleEmailChange}
                                required
                              />
                              <Button variant="primary" className='subscribe-btn' type="submit">
                                Subscribe
                              </Button>
                            </InputGroup>
                          </Form>
                        {subscribed && <p className="text-success mt-2">Thank you for subscribing!</p>}
                    </div>
                  </motion.div>  
                </Col>
            </Row>
            <Container fluid className="tech-carousel my-4 px-0">
              <Carousel controls={false} indicators={false} interval={2000}>
                <Carousel.Item>
                  <div className="d-flex justify-content-around align-items-center">
                    <img src={reactIcon} alt="React" style={{ height: '50px' }} />
                    <img src={bootstrapIcon} alt="Bootstrap" style={{ height: '50px' }} />
                    <img src={nodeIcon} alt="Node.js" style={{ height: '50px' }} />
                    <img src={mysqlIcon} alt="MySQL" style={{ height: '50px' }} />
                    {/* Add more icons as needed */}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className="d-flex justify-content-around align-items-center">
                    <img src={wordpressIcon} alt="Wordpress" style={{ height: '50px' }} />
                    <img src={androidIcon} alt="Wordpress" style={{ height: '50px' }} />
                    <img src={shopifyIcon} alt="Shopify" style={{ height: '50px' }} />
                    <img src={appleIcon} alt="Wordpress" style={{ height: '50px' }} />
                    {/* Add more icons as needed */}
                  </div>
                </Carousel.Item>
                {/* You can add more Carousel.Items if you have multiple sets of icons */}
              </Carousel>
            </Container>
          </div>
        </Container>
      </div>
      <ServicesCards/>
      <Projects/>
      <Pricing/>
    </>
  )
}
export default Home;
